import { Button } from 'antd';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { Parser } from 'json2csv';
import { get, isEmpty } from 'lodash';
import React from 'react';
import BookingApi from '../../functions/api/booking/BookingApi';
import { columnTitles, TABLE } from './columns';

dayjs.extend(utc);

export default function (props) {
  const { currentDataSource } = props;
  let levels;

  const exportCsv = async (fields) => {
    levels = levels || (await BookingApi.getLevels());
    const bookingDateFields = [
      'book_crta',
      'book_rent_date',
      'book_rental_date_actual',
      'book_retun_date',
      'book_return_date_actual',
    ];

    const bookings = currentDataSource.map((r) => {
      Object.keys(r).forEach((key) => {
        if (bookingDateFields.includes(key)) {
          r[key] = dayjs(r[key]).utcOffset(7).format('YYYY-MM-DD HH:mm:ss');
        }
      });

      const insurance = get(r, ['bookingAddons', '0'], false);
      if (insurance) {
        r.insurance = insurance.price.toString();

        if (!isEmpty(insurance.actual_price)) {
          r.insurance += `-> ${insurance.actual_price}`;
        }
      }

      // convert book_stt_id -> book_stt_name
      return {
        ...r,
        book_stt_id: levels.find((l) => l.book_stt_id == r.book_stt_id)
          .book_stt_name,
      };
    });

    const parser = new Parser({ fields });
    const csvData = parser.parse(bookings);

    const blob = new Blob(['\ufeff', csvData]);
    const link = document.createElement('a');
    link.download = `exported-${dayjs().format('YYYYMMDD-HHmmss')}.csv`;
    link.href = URL.createObjectURL(blob);

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const exportColumns = columnTitles
    .filter((t) => t.hideOn !== TABLE.CSV)
    .map((item) => {
      let value = item.dataIndex;

      if (Array.isArray(value)) {
        value = item.dataIndex.join('.');
      }
      return { label: item.title, value };
    });

  return (
    <>
      <Button
        key="submit"
        type="default"
        className="pull-right"
        onClick={() => exportCsv(exportColumns)}
      >
        Export Filtering Data
      </Button>
    </>
  );
}
